import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { generatePath, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfigContext from 'app/context/config';
import {
  Ticket,
  withTicket,
  SelectionTotal,
  SelectionTotalMobile,
  withSelection
} from 'app/modules/order';
import { Button } from 'app/components';

import { Page, RowButton } from '../styles';
import { StepSeatsAside, SeatPlanNote } from './styles';
import SittingPlan from '../SittingPlan';
import { useSelector } from 'react-redux';
import { usePayment } from 'app/hooks';

const propTypes = {
  orderRequest: PropTypes.func.isRequired,
  buy: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  wizard: PropTypes.shape({
    adult: PropTypes.number.isRequired,
    child: PropTypes.number.isRequired,
    packageRegular: PropTypes.number.isRequired,
    packageChild: PropTypes.number.isRequired,
    packageReduced: PropTypes.number.isRequired,
    packageClub: PropTypes.number.isRequired,
  }).isRequired,

  isOrdered: PropTypes.bool.isRequired,
  movieCinemaId: PropTypes.string.isRequired,
  sessionData: PropTypes.object.isRequired,
  bookingCount: PropTypes.func.isRequired,
};

const TicketWrapped = withTicket('session')(Ticket);
const SelectionWrapped = withSelection('session')(SelectionTotal);
const SelectionMobileWrapped = withSelection('session', false)(SelectionTotalMobile);

const StepSeats = ({ orderRequest, buy, wizard, isOrdered, movieCinemaId, history: { push }, sessionData, bookingCount, requestSesseionsTickets, setConcessionOnServer, setConcessionComboOnServer, setConcessionData }) => {
  const [t] = useTranslation();
  const { routes } = useContext(ConfigContext);

  const location = useLocation();
  const email = location?.state?.email;
  const promotionId = location?.state?.promotionId;
  const cinemaId = location?.state?.cinemaId;

  const sessionPassPlanData = useSelector(state => state?.sessionsTickets?.sessionsPassData);
  const sessionBookingCountData = useSelector(state => state?.sessionsTickets?.sessionsBookingCount);
  const seatPlanData = useSelector(state => state?.sessionsTickets?.plan);
  const orderData = useSelector(state => state.order);
  const [sessionSeatPlanValue, setSessionSeatPlanValue] = useState([]);

  const operaSessionsData = location?.state?.operaSessionsData;

  const cinemas = useSelector(state => state?.cinemas?.cinemas);
  const concessionsaleData = cinemas?.filter((item) => {
    const cinemaId = location?.pathname?.split("/")[3]?.split('-')[0];
    return item?.id === cinemaId;
  });
  const country = process.env.REACT_APP_COUNTRY;

  useEffect(() => {
    setConcessionOnServer(null);
    setConcessionComboOnServer(null);
    setConcessionData({
      normalSession: {},
      comboSession: {},
    });
  }, []);

  useEffect(() => {
    if (email) {
      bookingCount({ cinemaId: Number(movieCinemaId.split("-")[0]), email: email, promotionId: promotionId });
    }

    if (seatPlanData && seatPlanData.rows) {
      const setFinalPlanData = seatPlanData.rows
        .flatMap(row => row.seats.filter(seat => seat.statusCalculated === 99))
        .map(seat => seat.position);
      setSessionSeatPlanValue(setFinalPlanData);
    }
  }, [seatPlanData]);

  useEffect(() => {
    if (email && !sessionPassPlanData?.deal?.cinemaId && !sessionPassPlanData?.sessions?.[0]?.sessionId && promotionId) {
      if (promotionId) {
        requestSesseionsTickets({ permotionId: promotionId, cinemaId: cinemaId });
      }
    }
  }, [sessionPassPlanData?.sessions?.[0]?.sessionId, sessionPassPlanData?.deal?.cinemaId, promotionId]);

  const next = useCallback(() => {
    // concessionsaleData[0]?.concessionsale
    //     ? push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }))
    //     : push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }))
    if ((email && sessionSeatPlanValue && sessionBookingCountData && sessionPassPlanData?.deal?.cinemaId && sessionPassPlanData?.sessions?.[0]?.sessionId)) {
      orderRequest(sessionPassPlanData?.deal?.cinemaId, sessionPassPlanData?.sessions?.[0]?.sessionId, null, email, sessionPassPlanData?.deal?.promotionId, sessionSeatPlanValue, sessionBookingCountData);
    } else if (country === 'aut' && concessionsaleData && concessionsaleData[0]?.concessionsale) {
      push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }))
      // push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }))
    }
    else {
      push({
        pathname: generatePath(routes.stepCheckout.pattern, { movieCinemaId }),
        state: { isAboId: location?.state?.isAboId, aboId: location?.state?.aboId }
      });
      // push({
      //   pathname: generatePath(routes.stepCheckout.pattern, { movieCinemaId })
      // });
    }
    // eslint-disable-next-line

  }, [movieCinemaId, sessionSeatPlanValue, sessionBookingCountData, sessionPassPlanData]);

  usePayment(orderData);

  return (
    <Page className="_seatplan">
      <SittingPlan wizardData={{ isBonus: false, wizard }} />

      <StepSeatsAside>
        <TicketWrapped type="compact" withTopTitle operaSessionsData={operaSessionsData}>
          <SelectionWrapped buy={buy} />
        </TicketWrapped>
        {
          !isOrdered &&
          <div>
            <RowButton>
              <Button isPrimary disabled={email ? false : !email ? true : !isOrdered} onClick={next}>
                {t('purchase.next')}
              </Button>
            </RowButton>
            <SeatPlanNote>{t('purchase.plan_note')}</SeatPlanNote>
          </div>
        }
        <SelectionMobileWrapped isOrdered={isOrdered} buy={buy} />
      </StepSeatsAside>
    </Page>
  );
};

StepSeats.propTypes = propTypes;
export default StepSeats;
